
import React, { PropTypes } from 'react';
import CSSModules           from 'react-css-modules';
import { reduxForm }        from 'redux-form';

import style from './style.scss';

import timetableRepository from '../../services/timetables';
import formInitialiser     from '../../services/formInitialiser';
import FormSubmitter       from '../../services/formSubmitter';

import Button        from '../Button';
import Input         from '../Input';
import InlineError   from '../InlineError';
import InputGroup    from '../InputGroup';
import Label         from '../Label';
import FontIcon      from '../FontIcon';
import TimetableRow  from '../TimetableRow';

class TimetableForm extends React.Component {

    _removeTimetableRow(index) {

        this.props.fields.periods.removeField(index);
    }

    render() {

        const { fields: { name, periods }, handleSubmit, submitting } = this.props;

        const submitSuccess = this.props.submitSuccess;
        
        var formSubmitter = new FormSubmitter({
            create: timetableRepository.create,
            update: timetableRepository.update,
            submitSuccess: submitSuccess
        });

        return (
            <form onSubmit={ handleSubmit(formSubmitter.getSubmit(this.props.formMode)) }>

                <InputGroup>
                    <Label>Name</Label>
                    <Input { ...name } errors={ name.error } />
                    <InlineError errors={ name.error } />
                </InputGroup>

                <InputGroup>
                    <Label>Timetable</Label>

                    <div styleName="timetable-row-container">

                        {
                            periods.map((period, index) => {

                                return (
                                    <TimetableRow key={ period.id.value }
                                                  index={ index }
                                                  periods={ periods }
                                                  period={ period }
                                                  showRemoveButton={ index !== 0 || periods.length > 1 }
                                                  removeButtonClicked={ this._removeTimetableRow.bind(this) } />
                                );
                            })
                        }

                    </div>

                    <Button type="button"
                            className={ style['add-task-button'] }
                            onClick={ periods.addField.bind(this, { id: periods.length }, periods.length) }>

                        <FontIcon textPosition="right" iconName="plus" />
                        <span>Add row</span>

                    </Button>

                </InputGroup>

                <Button disabled={ submitting }
                        autoWidth="true"
                        type="submit"
                        theme="success">
                    Save
                </Button>

            </form>
        );
    }
}

const reduxFormParams = {
    form: 'timetable',
    fields: ['id', 'name', 'periods[].id', 'periods[].time', 'periods[].description']
};

function mapStateToProps(state) {

    const { formMode, defaultTimetable, timetableToEdit } = state.timetableList;

    return {
        initialValues: formInitialiser.getInitialValues(formMode, defaultTimetable, timetableToEdit),
        formMode
    };
}

export default reduxForm(reduxFormParams, mapStateToProps)(CSSModules(TimetableForm, style));


// WEBPACK FOOTER //
// ./components/TimetableForm/index.js